import { render, staticRenderFns } from "./RecoverUser.vue?vue&type=template&id=d1f9dfd2&"
import script from "./RecoverUser.vue?vue&type=script&lang=js&"
export * from "./RecoverUser.vue?vue&type=script&lang=js&"
import style0 from "./RecoverUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports